import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from './pages/intranet_company/Auth/Login';
import RecoveryPassword from './pages/intranet_company/Auth/RecoveryPassword';
import PrivateMiddlewareCompany from './routes/middleware/PrivateMiddlewareCompany';
import PublicMiddleware from './routes/middleware/PublicMiddleware';
import MainThemeCompany from './template/MainTheme/layouts/intranet_company';
import PublicMiddlewareCompany from './routes/middleware/PublicMiddlewareCompany';
import RegisterCompany from './pages/intranet_company/Auth/Register';
import MainThemeAdmin from './template/MainTheme/layouts/intranet_admin';
import Preferences from './pages/intranet_admin/Preferences';
import Events from './pages/intranet_company/Events';
import EventEdit from './pages/intranet_company/Events/subpages/EventEdit';
import EventProgram from './pages/intranet_company/Events/subpages/EventProgram';
import EventGuest from './pages/intranet_company/Events/subpages/EventGuest';
import EventParticipation from './pages/intranet_company/Events/subpages/EventParticipantion';

const CompanyRoutes = () => (
    <Switch>
        <Route path="/company/login">
            <PublicMiddlewareCompany>
                <MainThemeCompany showLayouts={false}>
                    <Login />
                </MainThemeCompany>
            </PublicMiddlewareCompany>
        </Route>
        <Route path="/company/register">
            <PublicMiddlewareCompany>
                <MainThemeCompany showLayouts={false}>
                    <RegisterCompany />
                </MainThemeCompany>
            </PublicMiddlewareCompany>
        </Route>
        <Route path="/company/recovery-password">
            <PublicMiddlewareCompany>
                <MainThemeCompany showLayouts={false}>
                    <RecoveryPassword />
                </MainThemeCompany>
            </PublicMiddlewareCompany>
        </Route>
        <PrivateMiddlewareCompany>
            <Switch>
                <Route path="/company/events/:id/edit">
                    <MainThemeCompany showLayouts={true}>
                        <EventEdit />
                    </MainThemeCompany>
                </Route>
                <Route path="/company/events/:id/program">
                    <MainThemeCompany showLayouts={true}>
                        <EventProgram/>
                    </MainThemeCompany>
                </Route>
                <Route path="/company/events/:id/guests">
                    <MainThemeCompany showLayouts={true}>
                        <EventGuest/>
                    </MainThemeCompany>
                </Route>
                <Route path="/company/events/:id/participants">
                    <MainThemeCompany showLayouts={true}>
                        <EventParticipation/>
                    </MainThemeCompany>
                </Route>
                <Route path="/company/events">
                    <MainThemeCompany showLayouts={true}>
                        <Events />
                    </MainThemeCompany>
                </Route>
                <Route path="/company">
                    <MainThemeCompany showLayouts={true}>
                        <></>
                    </MainThemeCompany>
                </Route>
            </Switch>
        </PrivateMiddlewareCompany>
    </Switch>
);

export default CompanyRoutes;
